import React from 'react'
import { Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    eliminarFC_01AnexoInstalacion,
    eliminarFC_01AnexoInstalacionBD,
    eliminarFC_01AnexoUnidadAlmacen,
    eliminarFC_01AnexoUnidadAlmacenBD,
    eliminarFC_01AnexoUnidadEnvasado,
    eliminarFC_01AnexoUnidadEnvasadoBD,
    eliminarFC_01AnexoUnidadProduccion,
    eliminarFC_01AnexoUnidadProduccionBD,
    obtenerFC_01AnexoUnidadMap,
    obtenerFC_01AnexoResponsableUnidadMap
} from '../../../redux/DucksBeneficiario/FC_01Ducks'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function TablaAnexos(props) {

    const dispatch = useDispatch()
    const modoEdicionBorrador = useSelector(store => store.FC_01Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_01Solicitud.modoCorreccion)
    const validacionInstalacion = useSelector(store => store.FC_01Solicitud.validacionInstalacion)
    /****MODAL */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [parametros, setParametros] = React.useState()
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setParametros(data.parametros)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setParametros()
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'eliminarAnexo':
                                        eliminarAnexo(parametros)
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const eliminarAnexoModal = (params) => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de eliminar un anexo, esta acción no se podrá revertir.`,
            accion: 'eliminarAnexo',
            parametros: params
        })
    }

    const eliminarAnexo = (params) => {
        if (modoEdicionBorrador) {
            props.handdleDeleteOptionFile(params.row.id)
            dispatch(eliminarFC_01AnexoInstalacionBD({
                idfc01_solicitudregistro: params.row.idfc01_solicitudregistro,
                idanexo: params.row.idanexo,
                id: params.row.id
            }))
        } else {
            props.handdleDeleteOptionFile(params.id)
            dispatch(eliminarFC_01AnexoInstalacion(params.id))
        }
        handleCloseModal()
    }

    const editarAnexo = (params) => {
        switch (params.row.tipoInstalacion) {
            case 'Unidad Almacén':
                props.history.push('/fc_01AnexoAlmacen', { idEdit: params.id })
                break;
            case 'Unidad Envasado':
                props.history.push('/fc_01AnexoEnvasado', { idEdit: params.id })
                break;
            case 'Unidad Producción':
                props.history.push('/fc_01AnexoProduccion', { idEdit: params.id })
                break;
            default:
                break;
        }
    }

    const corregirAnexo = async (params) => {
        switch (params.row.tipoInstalacion) {
            case 'Unidad Almacén':
                await dispatch(obtenerFC_01AnexoResponsableUnidadMap({responsables:params.row.responsables}))
                await dispatch(obtenerFC_01AnexoUnidadMap(params.row.idiformaciongeneral))
                props.history.push('/fc_01AnexoAlmacen', { idEdit: params.id })
                break;
            case 'Unidad Envasado':
                await dispatch(obtenerFC_01AnexoResponsableUnidadMap({responsables:params.row.responsables}))
                await dispatch(obtenerFC_01AnexoUnidadMap(params.row.idiformaciongeneral))
                props.history.push('/fc_01AnexoEnvasado', { idEdit: params.id })
                break;
            case 'Unidad Producción':
                await dispatch(obtenerFC_01AnexoResponsableUnidadMap({responsables:params.row.responsables}))
                await dispatch(obtenerFC_01AnexoUnidadMap(params.row.idiformaciongeneral))
                props.history.push('/fc_01AnexoProduccion', { idEdit: params.id })
                break;
            default:
                break;
        }
    }

    const columns = [
        { field: 'anexo', headerAlign: 'center', headerName: 'Tipo de instalación', width: 150 },
        { field: 'alias', headerAlign: 'center', headerName: 'Alias', width: 120 },
        { field: 'domicilio', headerAlign: 'center', headerName: 'Domicilio', width: 600 },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Eliminar', width: 80,
            renderCell: (params) => (
                !modoCorreccion &&
                <button onClick={() => {
                    eliminarAnexoModal(params)
                }} className='btn btn-danger btn-sm'>Eliminar</button>
            )
        },
        {
            field: 'accionEditar', headerAlign: 'center', headerName: 'Editar', width: 80,
            renderCell: (params) =>
            (
                
                modoCorreccion ? 
                (validacionInstalacion?(<button onClick={() => corregirAnexo(params)} className='btn btn-warning btn-sm' >Corregir</button>):'') 
                : (<button onClick={() => editarAnexo(params)} className='btn btn-warning btn-sm'>Editar</button>)

            )
        }
    ]


    const rows = [];
    const data = props.rows

    if (data) {
        if (data.length > 0) {
            data.map(item => {
                if (item.data) {
                    let anexoRow = Object.assign({}, item.data)
                    anexoRow.anexo =anexoRow.tipoInstalacion
                    rows.push(anexoRow)
                } else {
                    let anexoRow = Object.assign({}, item)
                    anexoRow.anexo = anexoRow.tipoInstalacion
                    rows.push(anexoRow)
                }
            })
        }
    }

    return (
        <div className='row ms-1 mt-1'>
            <div className='row'>
                <div className='row justify-content-md-center divBorderNaranja'>
                    <h6 className='text-center text-dark'>Instalaciones registradas</h6>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-12' style={{ color: 'black' }}>
                        <div style={{ height: (130 + (data.length * 50)), width: '100%', color: 'black' }}>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                // pageSize={10}
                                 rowsPerPageOptions= 'none'
                                sx={{
                                    boxShadow: 0,
                                    border: 0,
                                    color: 'black',
                                    backgroundColor: 'white !important'
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            {modalComponent()}
        </div>
    )
}

export default withRouter(TablaAnexos)
